// @flow
import * as React from 'react';
import { useParams } from 'react-router-dom';
import { keycloak } from '@coverright/shared/keycloak';
import { SalesQualified } from './sales-qualified';
import { useSalesQualifiedFutureQuery } from '../../../../shared';


export const FutureSalesQualified = () => {
  const {agentId} = useParams<{ agentId?: string }>();

  return (
    <SalesQualified suffix={'Future'}
                    dataSource={useSalesQualifiedFutureQuery}
                    title={'Future Sales Qualified'}
                    agent={agentId || keycloak?.tokenParsed?.sub} />
  );
};
